"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import { AppShell } from "@components/layout/app-shell";

/**
 * Admin AppShell for branch routes, except Coach App preview (`…/coach/…`)
 * which renders full-bleed without portal header/sidebar.
 */
export function BranchRouteShell(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  const pathname = usePathname() ?? "";
  const isCoachApp = /\/coach(\/|$)/.test(pathname);
  if (isCoachApp) {
    let t1;
    if ($[0] !== children) {
      t1 = <>{children}</>;
      $[0] = children;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== children) {
    t1 = <AppShell>{children}</AppShell>;
    $[2] = children;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}